/**
 * ExtranetProtectedRoute — Fase 4 Extranet KB
 * Rota protegida: exige sessão + kb_external_users ativo no tenant.
 */
import { Navigate, useParams } from 'react-router-dom';
import { useExtranetAuth } from '@/hooks/useExtranetAuth';
import { Loader2 } from 'lucide-react';

interface Props {
  children: React.ReactNode;
  /** Se true, permite acesso mesmo com is_active=false (aguardando aprovação). */
  allowPending?: boolean;
}

export function ExtranetProtectedRoute({ children, allowPending = false }: Props) {
  const { user, externalUser, ready, tenantSlug } = useExtranetAuth();
  const { tenantSlug: paramSlug } = useParams<{ tenantSlug: string }>();
  const slug = tenantSlug || paramSlug || '';

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={`/extranet/${slug}/login`} replace />;
  }

  if (!externalUser) {
    return <Navigate to={`/extranet/${slug}/login`} replace />;
  }

  if (!externalUser.is_active && !allowPending) {
    return <Navigate to={`/extranet/${slug}/aguardando`} replace />;
  }

  return <>{children}</>;
}
